module.exports = __webpack_public_path__ + "img/提现记录.c5257506.svg";